import {
    LOG_IN_USER,
    FETCH_USER,
} from './actionTypes';



const loginUser = (username, password) => ({
    type: LOG_IN_USER,
    payload: {
        username: username.trim().toLowerCase(), password
    },
    errors: null
})

const fetchUser = () => ({
    type: FETCH_USER,
    payload: { user: {}},
    errors: null
})

export {
    fetchUser, loginUser
}